module.exports = __webpack_public_path__ + "img/lendful.e6aefdb8.png";